<template>
  <div class="form-group">
    <textarea :class="{error}" class="form-control" cols="30" rows="10"
      v-bind:value="JSONValue"
      v-on:input="parseAndInput($event.target.value)">
    </textarea>
  </div>
</template>

<script>
export default {
  name: 'JSONEditor',
  data: function(){
    return {
      error: false,
    }
  },
  props: {
    value: Object,
  },
  computed: {
    JSONValue() {
      return JSON.stringify(this.value, null, 4);
    }
  },
  methods: {
    parseAndInput(value) {
      try {
        let JSONValue = JSON.parse(value)
        this.error = false;
        this.$emit('input', JSONValue)
      } catch(err) {
        this.error = true;
      }
    }
  }
}
</script>

<style scoped>
textarea {

}
.error {
  border: 4px solid red;
}
</style>